// Get the element by its ID
let parallaxElement = document.querySelector('.content-container');

// Variables to track scroll position
let scrollPosition = 0;
let ticking = false;

// Parallax factor (adjust to control the effect intensity - smaller values create more subtle effects)
const parallaxFactor = 0.3;

// Function to update the element's position
function updatePosition() {
  // Calculate the new position based on the scroll position and parallax factor
  const yOffset = scrollPosition * parallaxFactor;
  
  // Apply the transform using translate3d for better performance
  parallaxElement.style.setProperty('--offset-position', `${-yOffset}px`);
  
  // Reset the ticking flag
  ticking = false;
}

// Scroll event listener
window.addEventListener('scroll', () => {
  // Store the current scroll position
  scrollPosition = window.scrollY;
  
  // Use requestAnimationFrame to optimize performance
  if (!ticking) {
    window.requestAnimationFrame(() => {
      updatePosition();
    });
    
    ticking = true;
  }
});

// Initialize the position when the page loads
window.addEventListener('load', () => {
  parallaxElement = document.querySelector('.content-container');
  if (parallaxElement) {
    updatePosition(); 
    return;
  }
});